import { SET_LOCALE_DATA } from './actionTypes'

export const setLocaleData = locale => ({
  type: SET_LOCALE_DATA,
  locale
})
